import {
  Configuration,
  RedirectRequest,
  SilentRequest,
  PublicClientApplication,
  EventMessage,
  EventType,
} from '@azure/msal-browser';
// import { basename } from "../routes/basename";

const instance = import.meta.env.VITE_B2C_INSTANCE;
const domain = import.meta.env.VITE_B2C_DOMAIN;
const signUpSignInPolicy = import.meta.env.VITE_B2C_SIGNUP_SIGNIN_POLICY;
const passwordResetPolicy = import.meta.env.VITE_B2C_PASSWORD_RESET_POLICY;
const clientId = import.meta.env.VITE_B2C_CLIENT_ID;
const apiScope = import.meta.env.VITE_B2C_API_SCOPE;
const redirectUri = import.meta.env.VITE_B2C_REDIRECT_URI;
/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
  names: {
    signUpSignIn: signUpSignInPolicy,
    passwordReset: passwordResetPolicy,
  },
  authorities: {
    signUpSignIn: {
      authority: `${instance}/${signUpSignInPolicy}`,
    },
    passwordReset: {
      authority: `${instance}/${passwordResetPolicy}`,
    },
  },
  authorityDomain: domain,
} as const;

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [domain],
    redirectUri: redirectUri,
    postLogoutRedirectUri: 'https://www.westminster.gov.uk/',
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false, // Disables WAM Broker
  },
};

export const forgotPasswordRequest: RedirectRequest = {
  authority: b2cPolicies.authorities.passwordReset.authority,
  scopes: [apiScope],
};

export const loginRequest: RedirectRequest = {
  prompt: 'login',
  authority: b2cPolicies.authorities.signUpSignIn.authority,
  scopes: [apiScope],
};

export const logOutRequest: RedirectRequest = {
  authority: b2cPolicies.authorities.signUpSignIn.authority,
  scopes: [apiScope],
};

export const tokenRequest: SilentRequest = {
  authority: b2cPolicies.authorities.signUpSignIn.authority,
  scopes: [apiScope],
};

export const msalInstance = new PublicClientApplication(msalConfig);
